module.exports = __webpack_public_path__ + "img/LEON.67768a50.svg";